import { isNil, deburr } from 'lodash';

/* eslint-disable quotes */
const ALLOWED_PUNCTUATION = `\\s'-`;
/* eslint-enable quotes */
const BLOCKED_NAMES = new Set(['myinfo', 'noname', 'nofirstname', 'nolastname']);

/**
 * 
 * Allowed characters 
 *  26 letters of the English language alphabet (all capitalizations allowed)
 * [Space] , [dash]-, or [Apostrophe] ‘
 * 
 * THIS IS DUPLICATED ON THE SERVER-SIDE: lib/util/nameUtil
 */
export const hasInvalidCharacter = (name) => {
    if (isNil(name)) {
        return true;
    }
    const normalizedName = deburr(name);
    const regex = new RegExp(`[^A-Za-z${ALLOWED_PUNCTUATION}]`, 'g');
    return normalizedName?.match(regex) !== null;
};

/**
 * Prevent names with the following
 * My Info 
 * No Name
 * No First Name
 * No Last Name
 * https://engineering.paypalcorp.com/confluence/display/CREDITPR/Updated+name+validations+in+CAPE
 * 
 * 
 * THIS IS DUPLICATED ON THE SERVER-SIDE: lib/util/nameUtil
 */
export const isBlocklistName = (name) => {
    if (isNil(name)) {
        return true;
    }
    const regex = new RegExp(`[${ALLOWED_PUNCTUATION}]`, 'g');
    const standarizedName = deburr(name)?.toLowerCase()?.replace(regex, '');
    return BLOCKED_NAMES.has(standarizedName);
};


// returns a Redux Form validation function
export const isValidName = (msg) => (name, allFields) => {
    if (hasInvalidCharacter(name)) {
        return {
            msg,
            className: 'hasError'
        };
    } else if (isBlocklistName(name) || isBlocklistName(`${allFields?.firstName} ${allFields?.lastName}`)) {
        return {
            msg,
            className: 'hasError'
        };
    }
};
